import { Card, Column, Row } from "@components/Layout";
import { Template } from "@components/Template";
import { Image } from "@kobalte/core";
import type { VoidComponent } from "solid-js";
import { AuthorImageColumn, AuthorRow, TracklistImage } from "./styled";

const HeaderTemplate: VoidComponent = () => {
	return (
		<Card maxWidth="756px" padding="15px">
			<Row>
				<Column gap="10px">
					<Row gap="10px" alignItems="stretch">
						<TracklistImage>
							<Image.Fallback>
								<Template w="100%" h="100%" />
							</Image.Fallback>
						</TracklistImage>
						<Column justifyContent="space-between">
							<Template w="50%" h="35px" borderRadius="5px" />
							<AuthorRow justifyContent="space-between" alignItems="center">
								<Row gap="10px" alignItems="center">
									<Row alignItems="center" gap="5px" flexShrink={1}>
										<AuthorImageColumn>
											<Template w="100%" h="100%" borderRadius="50%" />
										</AuthorImageColumn>
										<Template w="100px" h="20px" borderRadius="5px" />
									</Row>
								</Row>
								<Template w="40px" h="40px" borderRadius="50%" />
							</AuthorRow>
							<Template w="150px" h="35px" borderRadius="15px" />
						</Column>
					</Row>
					<Row justifyContent="space-between">
						<Row gap="10px" w="max-content">
							<Template w="40px" h="40px" borderRadius="5px" />
							<Template w="40px" h="40px" borderRadius="5px" />
						</Row>
						<Row w="max-content" gap="10px">
							<Template w="40px" h="40px" borderRadius="5px" />
							<Template w="40px" h="40px" borderRadius="5px" />
						</Row>
					</Row>
				</Column>
				<Column w="35px" />
			</Row>
		</Card>
	);
};
export default HeaderTemplate;
